/////////////////////////////////////////////////
// Standard scroll will toggle hide/show all elements with
// the target class
//
// https://github.com/mymuesli/mymuesli-web/wiki/jQuery-Solutions
//
////////////////////////////////////////////////////////////

class ToggleTarget {
    constructor(element) {
        /**
         * our object
         * @type {object}
         */
        this.element = element;
    }

    run() {
        var element = this.element;
        var targets = element.data('comp-toggle-targets').split(',');

        if (targets) {
            targets.forEach(target => {
                if (this.element.hasClass('active')) {
                    this.element.removeClass('active');
                    $(`.${target}`).slideUp();
                } else {
                    this.element.addClass('active');
                    $(`.${target}`).slideUp(function(){
                        $(this).css('display', ''); // remove inline property after slideUp
                    });
                }
            });
        }
    }
}

$(function(){
    // TOGGLE TARGET
    $(this).on('click', '.comp-toggle-target', function(e){
        e.preventDefault();
        const toggleTarget = new ToggleTarget($(this));
        toggleTarget.run();
    });
});